import { FileParameter, ReadFileData } from '@lmt/shared-types';
import { createAction } from 'typesafe-actions';
import { MeasuredValue } from './types';

export const measuredValuesLoaded = createAction(
  'measurement/MEASURED_VALUES_LOADED',
)<MeasuredValue[]>();
export const fileLoaded = createAction(
  'measurement/FILE_LOADED',
)<FileParameter>();
export const pdfFileLoaded = createAction(
  'measurement/REPORT_FILE_LOADED',
)<FileParameter | null>();
export const importFinished = createAction('measurement/IMPORT_FINISHED')();
export const importRestarted = createAction('measurement/IMPORT_RESTARTED')();
export const importCancelled = createAction('measurement/IMPORT_CANCELLED')();
export const fileRead = createAction('measurement/FILE_READ')<ReadFileData>();
